<template>
    <div class="cookies-container">
        <div class="box-cookies">
            <p class="msg-cookies">O site utiliza cookies fins analíticos e publicitários para uma melhor navegação em sua plataforma digital, relacionado com as suas preferências, segundos os seus hábitos e o seu perfil. Para maiores informações, você pode visitar nossos
                <a :href="$baseUrl+'page/politica-privacidade'">termos de uso e  políticas de privacidade</a>
            </p>
            <button class="btn-cookies" @click="cookies">Aceitar</button>
        </div>
    </div>
</template>

<script>
    export default{
        mounted(){
            this.cookies();
        },
        methods:{
            cookies(){
            const container = document.querySelector('.cookies-container');
            const save = document.querySelector('.btn-cookies');

            const localPref = JSON.parse(window.localStorage.getItem('cookies-pref'));
            if (localPref) handleSave(localPref);

            function handleSave() {
                container.style.display = 'none';
                window.localStorage.setItem('cookies-pref', JSON.stringify('accept'));
                }
            save.addEventListener('click', handleSave);
            }
        }
    }

</script>

<style>
    .cookies-container{
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        position: fixed;
        bottom: 6rem;
        left: 0;
        right: 0;
        padding: 0 32px;
        width: 100%;
        z-index: 1000;

        transform: 450ms;
    }

    .box-cookies{
        max-width: 1000px;
        background-color: rgba(0, 0, 0, 0.75);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.55);
        border-radius: 5px;
        padding: 1rem;
        display: grid;
        grid-template-columns: 1fr auto;
        margin: 0 auto;
        gap: 0.4rem;
        text-align: center;
    }

    .msg-cookies {
        color: rgb(177, 177, 177);
        font-size: 13.4px;
    }

    .msg-cookies a {
        color: white;
    }

    .btn-cookies {
        color: rgb(255, 255, 255);
        border-color: 1px solid #13a0ff;/* #27a4f8 */
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI',     Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        font-size: 1.4rem;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        background: #006db6;/* #3398DB */
        padding: 0.8rem 1rem;
        font-size: 15px;
    }

    @media (max-width: 500px){
        .cookies-container{
            grid-template-columns: 1fr;
        }

        .btn-cookies {
            grid-column: 1;
        }
    }

</style>
